import React  from 'react'
import './bookmark.css' 
import BottomNav from '../../components/bottomnav/BottomNav';
import Navbar from '../../components/navbar/Navbar';

function Bookmark() {   
    return (
        <>      
        <Navbar/>      
        <div className="bookmark">
            <div className="bookmark-title">Bookmarks feature will be enabled Soon...</div>
        </div>
         <BottomNav/>
        </>
     
    )
}

export default Bookmark
